export default "https://cdn-static.gokick.com/assets/e388117c7865c86e8cffce5bc7abacefcd582b49/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";